import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {Cloneable} from "@/common/Cloneable";
import {ItemOrderKind} from "@/modules/redactor/models/item-order/ItemOrderKind";
import {ItemOrder} from "@/modules/redactor/models/item-order/ItemOrder";
import {ItemTraderMode} from "@/modules/redactor/models/item/trader/ItemTraderMode";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";


export class ItemTraderConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(ItemTraderConfig, v) : SKIP;
        }, (v) => {
            return deserialize(ItemTraderConfig, v);
        });
    }

    constructor() {
        super();

        this._mode = null;
        this._activeOrders = 0;
        this._acceptOrders = [];
        this._customOrders = [];
        this._tutorialAllow = null;
        this._tutorialBlock = null;
        this._sideMenu = false;
    }

    get mode() {
        return this._mode;
    }

    set mode(value) {
        this._mode = value;
    }

    get activeOrders() {
        return this._activeOrders;
    }

    set activeOrders(value) {
        this._activeOrders = value;
    }

    get acceptOrders() {
        return this._acceptOrders;
    }

    set acceptOrders(value) {
        this._acceptOrders = value;
    }

    get customOrders() {
        return this._customOrders;
    }

    set customOrders(value) {
        this._customOrders = value;
    }

    get tutorialAllow() {
        return this._tutorialAllow;
    }

    set tutorialAllow(value) {
        this._tutorialAllow = value;
    }

    get tutorialBlock() {
        return this._tutorialBlock;
    }

    set tutorialBlock(value) {
        this._tutorialBlock = value;
    }

    get sideMenu() {
        return this._sideMenu;
    }

    set sideMenu(value) {
        this._sideMenu = value;
    }

    valid() {

        if (!this.mode || ItemTraderMode.isNone(this.mode)) {
            return false;
        }

        if (!Number.isInteger(this.activeOrders) || this.activeOrders <= 0) {
            return false;
        }

        if (this.acceptOrders.length === 0 && this.customOrders.length === 0) {
            return false;
        }

        if (this.customOrders && this.customOrders.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.tutorialAllow && !RedactorUtils.getTutorial(this.tutorialAllow)) {
            return false;
        }

        if (this.tutorialBlock && !RedactorUtils.getTutorial(this.tutorialBlock)) {
            return false;
        }

        return true;
    }

    empty() {
        return this.acceptOrders.length === 0 && this.customOrders.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemTraderConfig());
        } else if (target instanceof ItemTraderConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemTraderConfig, {
    _mode: alias("mode", ItemTraderMode.schema()),
    _activeOrders: alias("active_orders", Schema.primitive()),
    _acceptOrders: alias("accept_orders", list(ItemOrderKind.schema())),
    _customOrders: alias("custom_orders", list(ItemOrder.schema())),

    _tutorialAllow: alias("tutorial_allow", Schema.primitive()),
    _tutorialBlock: alias("tutorial_block", Schema.primitive()),
    _sideMenu: alias("side_menu", Schema.primitive())
});